import { z } from 'zod';

export const AddressSubValueSchema = z.object({
  name: z.string().optional(),
  phone: z.string().optional(),
  line1: z.string().optional(),
  line2: z.string().optional(),
  city: z.string().optional(),
  region: z.string().optional(),
  postalCode: z.string().optional(),
  country: z.string().length(2),
});

export type AddressSubValue = z.infer<typeof AddressSubValueSchema>;

export const AddressFieldValueSchema = z.object({
  billing: AddressSubValueSchema.optional(),
  shipping: AddressSubValueSchema.optional(),
  sameAsShipping: z.boolean().optional(),
});

export type AddressFieldValue = z.infer<typeof AddressFieldValueSchema>;
